// The navigation guard, pure (node tests): which navigations ask to confirm
// by themselves (NavigationGuard), what a link click is, when the browser
// warns before the page is closed or reloaded (DraftHost).

// The navigations the guard of the router asks about (useBlocker): the
// browser's Back and Forward (POP). The app's own navigations (PUSH,
// REPLACE) are not blocked: they asked already (useConfirmNavigation, the
// links), or they must not ask (the redirects of the variant pages, the
// opening of an item just created by its Save): nothing is asked twice.
export const guardsNavigation = ({ historyAction } = {}) =>
  historyAction === "POP";

// A location of the router as a destination of useConfirmNavigation
// ("/blocks/newItem?copy=b1": the scope rules read the pathname).
export const destinationOf = (location) =>
  location
    ? `${location.pathname ?? ""}${location.search ?? ""}${location.hash ?? ""}`
    : "";

// A click that the app navigates (the left button, no modifier key, no
// target): one that opens a new tab or window is the browser's.
export const isPlainClick = (event, target) =>
  event?.button === 0 &&
  !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) &&
  (!target || target === "_self");

// The onClick of a router <Link to={to}> whose navigation asks to confirm:
// onClick={confirmingClick(confirmNavigation, to)} (useConfirmNavigation). A
// plain click navigates through confirmNavigation (the link does not
// navigate by itself); a click that opens a new tab or window is left to
// the browser, as the link's href.
export const confirmingClick = (confirmNavigation, to) => (event) => {
  if (event.defaultPrevented || !isPlainClick(event)) return;
  event.preventDefault();
  confirmNavigation(to);
};

// The browser warns when the page is closed or reloaded with unsaved work:
// a draft not saved, or the form being edited with changes (unsavedData).
export const warnsOnUnload = ({ draftDirty = false, formDirty = false } = {}) =>
  Boolean(draftDirty || formDirty);
